let newsListAbortController = null
let isLoading = false
let pageToLoad = 2
/**
 * @type {number}
 */
let numberOfPages

function parseNumberOfPages(value) {
  const parsed = parseInt(value ?? '')
  return Number.isNaN(parsed) ? 99 : parsed
}

function buildFormData(form, page) {
  const formData = new URLSearchParams(new FormData(form))
  if (page) {
    formData.append('tx_news_pi1[currentPage]', page)
  }
  return formData
}

async function GetNewsList(form, page) {
  const ajaxUrl = form.getAttribute('action')
  const container = 'news-container-' + form.dataset.container

  if (newsListAbortController) {
    newsListAbortController.abort()
  }
  newsListAbortController = new AbortController()

  try {
    const response = await fetch(ajaxUrl, {
      method: 'POST',
      body: buildFormData(form, page),
      signal: newsListAbortController.signal,
    })
    const result = await response.text()
    const doc = new DOMParser().parseFromString(result, 'text/html')

    const newsFormEl = doc.querySelector('form.news-filter-form')
    numberOfPages = parseNumberOfPages(newsFormEl?.dataset.numberOfPages)

    const ajaxContainer = doc.querySelector('#' + container)
    const headerSiteIntro = doc.querySelector('.news-tools__column--right')

    const containerEl = document.querySelector('#' + container)
    if (containerEl && ajaxContainer) containerEl.innerHTML = ajaxContainer.innerHTML

    const headerEl = document.querySelector('.news-tools__column--right')
    if (headerEl && headerSiteIntro) headerEl.innerHTML = headerSiteIntro.innerHTML

  } catch (e) {
    if (e.name !== 'AbortError') throw e
  }
}

function InitNewsList() {
  const newsEl = document.querySelector('.news')
  if (!newsEl) return

  const newsForm = newsEl.querySelector('form.news-filter-form')
  const newsTrigger = newsEl.querySelector('.news-list__trigger')

  numberOfPages = parseNumberOfPages(newsForm?.dataset.numberOfPages)

  document.querySelector('.news .news-tools')?.addEventListener('keyup', (e) => {
    if (!(e.target instanceof HTMLInputElement)) return
    const form = e.target.closest('form')
    if (form) GetNewsList(form, 0)
  })

  // disable (enter) submit
  newsForm?.addEventListener('submit', (e) => {
    e.preventDefault()
  })

  newsEl.addEventListener('click', (e) => {
    const link = e.target.closest('.page-navigation a')
    if (!link) return
    e.preventDefault()
    const page = link.dataset.page
    const form = link.closest('.news')?.querySelector('form')
    if (form) GetNewsList(form, page)
  })

  /**
   * @type {IntersectionObserverCallback}
   */
  const loadMoreNewsEntries = (entries) => {
    // we always observe exactly one element
    if (!entries[0]?.isIntersecting ?? false) {
      return
    }
    loadMoreNewsEntriesAjax(newsForm)
  }

  const loadMoreNewsEntriesAjax = async (form) => {
    if (isLoading || pageToLoad > numberOfPages) return

    isLoading = true
    newsTrigger?.classList.add('is-loading')

    const container = 'news-container-' + form.dataset.container

    if (newsListAbortController) {
      newsListAbortController.abort()
    }
    newsListAbortController = new AbortController()

    try {
      const response = await fetch(form.getAttribute('action'), {
        method: 'POST',
        body: buildFormData(form, pageToLoad),
        signal: newsListAbortController.signal,
      })
      const result = await response.text()
      const doc = new DOMParser().parseFromString(result, 'text/html')

      const ajaxContainer = doc.querySelector('#' + container)
      const containerEl = document.querySelector('#' + container)
      if (containerEl && ajaxContainer) {
        containerEl.insertAdjacentHTML('beforeend', ajaxContainer.innerHTML)
        const updatedNumberOfPages = parseInt(
          containerEl.querySelector('.pagination-info')?.dataset.pagination ?? ''
        )
        if (!Number.isNaN(updatedNumberOfPages) && updatedNumberOfPages > 0) {
          numberOfPages = updatedNumberOfPages
        }
      }

      pageToLoad++
    } catch (e) {
      if (e.name !== 'AbortError') throw e
    } finally {
      isLoading = false
      newsTrigger?.classList.remove('is-loading')
    }
  }

  // observe trigger
  const newsListTrigger = document.querySelector('.news-list__trigger')
  if (newsListTrigger) {
    const newsListObserver = new IntersectionObserver(loadMoreNewsEntries)
    newsListObserver.observe(newsListTrigger)
  }
}

InitNewsList()
